module.exports = __webpack_public_path__ + "static/img/bg-en.57cce4e0.png";